import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { FIR_AUTOFILL_DATA, CORPORATE_AUTOFILL_DATA} from "./type";

export const firAutofill = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.installation.firAutofill}?site_id=${id}`,
    
  );
  if (res) {
    const { data } = res;
    dispatch({ type: FIR_AUTOFILL_DATA, payload: data.response.data });
    return data.response.data;
  }
};

export const corporateAutofillData = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.installation.corporateAutofillData}?site_id=${id}`,
    
  );
  if (res) {
    const { data } = res;
    dispatch({ type: CORPORATE_AUTOFILL_DATA, payload: data.response.data });
    return data.response.data;
  }
};








